import { render, staticRenderFns } from "./top-head.vue?vue&type=template&id=b6a86ee0&"
import script from "./top-head.vue?vue&type=script&lang=js&"
export * from "./top-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports